<template>
  <g
    id="Gruppe_1484"
    data-name="Gruppe 1484"
    transform="translate(-195 -66)"
  >
    <rect
      id="Rechteck_816"
      data-name="Rechteck 816"
      width="24"
      height="24"
      transform="translate(195 66)"
      fill="none"
    />
    <g
      id="noun_Check_1675216"
      transform="translate(100.086 12.511)"
    >
      <g
        id="Gruppe_892"
        data-name="Gruppe 892"
        transform="translate(96.914 56.489)"
      >
        <path
          id="Pfad_1070"
          data-name="Pfad 1070"
          d="M3.084,9.056l3.751,4.337L17.793.382a.9.9,0,0,1,1.465,1.055L8.475,17.9a1.7,1.7,0,0,1-2.872.117l-5.45-6.5C-.9,9.993,1.794,7.825,3.084,9.056Z"
          transform="translate(0.086 -0.033)"
          fill="#455667"
          fill-rule="evenodd"
        />
      </g>
    </g>
  </g>
</template>
